import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Swiper from 'swiper';

import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum';
import { SECTIONS } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { ZoomImagePage } from '../zoom-image/zoom-image.page';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() slides: any[] = [];
  @Input() elementsImg?: string = '';
  @Input() page?: string = '';

  @ViewChild('sliders') swiperContainer: ElementRef | undefined;

  private openModal: any = null;
  private index = 0;
  public swiperInstance: HTMLElement & { swiper: Swiper } | undefined;
  public slideOpts = {
    initialSlide: 0
    , speed: 500
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , virtual: {
      cache: true
    }
    , pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      bulletActiveClass: 'swiper-pagination-bullet-active'
    }
    , observer: true
    , centeredSlides: false
  };

  constructor(
    private analytService: AnalyticsService
    , private modalZoom: ModalController
    , private sharedAnalyticsS: SharedAnalyticsService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.swiperContainer?.nativeElement) {
      this.swiperInstance = this.swiperContainer.nativeElement as HTMLElement & { swiper: Swiper };
      Object.assign(this.swiperInstance, this.slideOpts);
    }
  }

  ngOnDestroy() {
    if (this.openModal !== null) {
      this.openModal.dismiss()
    }
    if (this.swiperInstance) {
      this.swiperInstance.swiper.destroy();
    }
  }

  public ionSlideDidChange(event: any) {
    this.index = this.swiperInstance?.swiper.realIndex || 0;

    // TODO JAIR: VALIDAR INTERACCION
    this.analytService.fbAnalytics('interacciones', { data_categoria: this.page, data_accion: `/${this.page}`, data_etiqueta: `slider_${this.index}` })
  }

  public async slideTap() {
    if (this.openModal !== null) {
      this.openModal.dismiss()
    }
    this.sendScreenAnalytic()
    this.openModal = await this.modalZoom.create({
      component: ZoomImagePage
      , mode: 'md'
      , backdropDismiss: true
      , cssClass: 'ion-modal-zoom'
      , componentProps: { Imagen: this.slides[this.index].imagen_url }
    })

    await this.openModal.present()

    await this.openModal.onDidDismiss()

  }

  public sendScreenAnalytic() {
    const eventPageView = this.page === 'Mecanica' ? EAnalyticsPageViews.dynamicProgramZoomView : null
    if (eventPageView) {
      this.sharedAnalyticsS.trackPageView(eventPageView, SECTIONS.PROGRAMA);
    }
  }
}
